import { render, staticRenderFns } from "./ConfirmationDialog.vue?vue&type=template&id=54f1775a&scoped=true"
import script from "./ConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f1775a",
  null
  
)

export default component.exports